var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"reg-reason"},[_c('check-icon',{attrs:{"size":14}}),_c('span',[_vm._v(_vm._s(_vm.reason))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }